{
  "nl": {
    "login": {
      "loginPupil": {
        "activeSession": {
          "confirm": "Inloggen",
          "text": "Je bent momenteel ingelogd als docent. Om de toegangslink als leerling te gebruiken, word je eerst uitgelogd.",
          "title": "Uitloggen en inloggen als leerling?"
        },
        "appHandoff": {
          "continueInBrowser": "Doorgaan in de browser",
          "openApp": "Openen in de app",
          "subtitle": "Openen in de fobizz app?",
          "text": "Als je de fobizz app op dit apparaat hebt, wordt je klaslokaal daar direct geopend. Anders kun je hier in de browser verdergaan."
        },
        "error": "Deze code is helaas niet geldig. Heb je je misschien vergist?",
        "instruction": "Je ontvangt je toegangscode van je docent.",
        "logIn": "Inloggen",
        "subtitle": "Voer hier je 6-cijferige code in",
        "title": "Inloggen als leerling"
      },
      "loginTemporaryPupil": {
        "classFull": "Dit klaslokaal is helaas al vol. Neem contact op met je docent.",
        "error": "Deze link is helaas niet meer geldig.",
        "title": "Even geduld, je wordt binnenkort ingelogd..."
      }
    }
  }
}
